let activeTransition;

// Keep the old page visible beneath a feathered band that opens to both sides.
export function revealTheme(applyTheme, { duration = 850 } = {}) {
  activeTransition?.skipTransition();
  if (window.matchMedia?.("(prefers-reduced-motion: reduce)").matches || typeof document.startViewTransition !== "function") {
    applyTheme();
    return;
  }
  const root = document.documentElement;
  root.dataset.lumaThemeTransition = "active";
  let transition;
  try {
    transition = document.startViewTransition(applyTheme);
  } catch {
    delete root.dataset.lumaThemeTransition;
    applyTheme();
    return;
  }
  activeTransition = transition;
  transition.ready.then(() => {
    root.animate({ maskSize: ["0% 100%", "240% 100%"] }, {
      duration, easing: "cubic-bezier(0.22, 1, 0.36, 1)", fill: "forwards",
      pseudoElement: "::view-transition-new(root)",
    });
  }).catch(() => transition.skipTransition());
  transition.finished.catch(() => {}).finally(() => {
    if (activeTransition !== transition) return;
    activeTransition = undefined;
    delete root.dataset.lumaThemeTransition;
  });
}
